import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  ROUTES,
  WORKSPACE_ROLE_LEVEL,
  WORKSPACE_ROLE_PERMISSION
} from '../../common/constants';
import AccessControl from '../../components/AccessControl';
import EditPage from './EditPage';
import Pages from './Pages';
import AddPage from './component/AddPage';

const PagesWrapper = () => (
  <Switch>
    <Route
      path={ROUTES?.PAGES_MODULE}
      exact
      render={(props) => (
        <AccessControl
          modulePermissions={[
            {
              moduleKey: WORKSPACE_ROLE_PERMISSION.PAGE_MANAGEMENT,
              allowedPermissions: [
                WORKSPACE_ROLE_LEVEL.VIEW,
                WORKSPACE_ROLE_LEVEL.EDIT,
                WORKSPACE_ROLE_LEVEL.DELETE
              ]
            }
          ]}
        >
          <Pages {...props} />
        </AccessControl>
      )}
    />
    <Route
      path={`${ROUTES?.PAGES_MODULE}/add`}
      exact
      render={(props) => (
        <AccessControl
          modulePermissions={[
            {
              moduleKey: WORKSPACE_ROLE_PERMISSION.PAGE_MANAGEMENT,
              allowedPermissions: [
                WORKSPACE_ROLE_LEVEL.EDIT,
                WORKSPACE_ROLE_LEVEL.DELETE
              ]
            }
          ]}
        >
          <AddPage {...props} />
        </AccessControl>
      )}
    />
    <Route
      path={`${ROUTES?.PAGES_MODULE}/:id/edit`}
      exact
      render={(props) => (
        <AccessControl
          modulePermissions={[
            {
              moduleKey: WORKSPACE_ROLE_PERMISSION.PAGE_MANAGEMENT,
              allowedPermissions: [
                WORKSPACE_ROLE_LEVEL.EDIT,
                WORKSPACE_ROLE_LEVEL.DELETE
              ]
            }
          ]}
        >
          <EditPage {...props} />
        </AccessControl>
      )}
    />
    <Route
      exact
      path={`${ROUTES?.PAGES_MODULE}/:id`}
      render={() => <Redirect to={ROUTES?.PAGES_MODULE} />}
    />
  </Switch>
);

export default PagesWrapper;
